<template>
    <span>
        <div v-if="type==='heim'" @click="filter(item.heimTeam)" class="cursorStyle">
            <v-icon v-if="getTeamRecord(item, 'heim')"
                    color="blue" small class="mr-1">mdi-star</v-icon>
            <v-icon v-if="item.heim.result.spielerRecord"
                    color="blue" small class="mr-1">mdi-account-star</v-icon>
            <v-icon v-if="item.heim.protest"
                    color="error" small class="mr-1">mdi-alert</v-icon>
            <!--<v-icon v-if="item.vereine.heim.indexOf('rejected')!==-1"
                    color="primary" small class="mr-1">mdi-alert</v-icon>-->
            {{item.heimTeam}}
        </div>
        <div v-else @click="filter(item.gastTeam)" class="cursorStyle">
            {{item.gastTeam}}
            <!--<v-icon v-if="item.vereine.gast.indexOf('rejected')!==-1"
                    color="primary" small class="ml-1">mdi-alert</v-icon>-->
            <v-icon v-if="item.gast.result.spielerRecord"
                    color="blue" small class="ml-1">mdi-account-star</v-icon>
            <v-icon v-if="getTeamRecord(item, 'gast')"
                    color="blue" small class="ml-1">mdi-star</v-icon>
            <v-icon v-if="item.gast.protest"
                    color="error" small class="mr-1">mdi-alert</v-icon>
        </div>
    </span>
</template>

<script>
    export default {
        name: "tab-teams-with-icons",
        props: ['item', 'type'],
        data: () => ({
            filtered: ''
        }),
        methods: {
            getTeamRecord(item, type){
                return item[type].result.oeR || item[type].result.bR || item[type].result.mR;
            },
            filter(value){
                this.$emit('filtered', value);
            },
        },
    }
</script>

<style scoped>
    .cursorStyle{cursor: pointer}
</style>